import { CalendarOff } from 'lucide-react'
import { DATE_PRESETS } from '../utils/date-presets'
import { formatPresetSubtitle } from '../utils/format-date-field'
import { usePreferredHourCycle } from '../../utils/user-time-format'

interface PresetListProps {
  onSelect: (date: Date, label: string) => void
  /** Given only while a due date is set, so the list offers taking it off. */
  onClear?: () => void
}

export function PresetList({ onSelect, onClear }: PresetListProps) {
  const now = new Date()
  const hourCycle = usePreferredHourCycle()

  return (
    <div className="flex flex-col gap-0.5">
      {DATE_PRESETS.map((preset) => {
        const date = preset.getDate(now)
        return (
          <button
            key={preset.label}
            type="button"
            className="hover:bg-element-hover corner-smooth flex flex-col gap-0.5 rounded-lg bg-transparent px-3 py-2 text-left transition-colors"
            onClick={() => onSelect(date, preset.label)}
          >
            <span className="text-foreground type-ui-sm font-medium">{preset.label}</span>
            <span className="text-foreground-secondary type-ui-xs">{formatPresetSubtitle(date, hourCycle)}</span>
          </button>
        )
      })}
      {onClear && (
        <>
          {/* Inset to the buttons' own padding, so it reads as a divider between
              the dates to pick and the one move that picks none. */}
          <div className="mx-3 my-1 border-t" />
          <button
            type="button"
            className="hover:bg-element-hover corner-smooth text-foreground-secondary hover:text-foreground flex items-center gap-2 rounded-lg bg-transparent px-3 py-2 text-left transition-colors"
            onClick={onClear}
          >
            <CalendarOff aria-hidden="true" className="size-3.5 shrink-0" />
            <span className="type-ui-sm font-medium">Remove due date</span>
          </button>
        </>
      )}
    </div>
  )
}
